import { Fragment, useState } from "react";

import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

import Check from "./checkmark.png";
import {
  useOrgPk,
  useMyOrgInfo,
} from "../../Layout/AppMain/LoginStatusContext";
import { useQuery, useMutation } from "@apollo/client";
import { CHECK_DISCOUNT_STATUS, CREATE_CHECKOUT_URL } from "../../queries";

import registerExplainImage from "../../assets/utils/images/register_explain.png";
import { useSettingOrgTab } from "../../Layout/AppMain/SettingOrgTabContext";

const Pricing = () => {
  const { orgActiveTab, setOrgActiveTab } = useSettingOrgTab();
  const orgPk = useOrgPk();
  const userOrgInfo = useMyOrgInfo();
  const orgContract =
    userOrgInfo &&
    userOrgInfo.contract &&
    userOrgInfo.contract.plan &&
    userOrgInfo.contract.plan.name;

  const [cso, setCso] = useState(false);
  const [noOrgUserModal, setNoOrgUserModal] = useState(false);

  const noOrgUserModalToggle = () => setNoOrgUserModal(!noOrgUserModal);

  const { loading, error, data } = useQuery(CHECK_DISCOUNT_STATUS, {
    variables: { id: orgPk },
  });

  // Create Checkout URL
  const [createCheckoutUrl, { resultData }] = useMutation(CREATE_CHECKOUT_URL);
  const checkout = async (planId) => {
    if (!orgContract || orgContract === "Free") {
      try {
        const url = await createCheckoutUrl({
          variables: { contractId: planId },
        });
        const { checkoutSubscription } = url.data;
        window.location.href = checkoutSubscription.url;
      } catch (err) {
        alert(err);
      }
    } else {
      alert(
        `既に${orgContract}をご契約中です、契約内容を変更する場合はお問合せフォームよりご連絡ください。`
      );
    }
  };

  const discountStatus =
    data &&
    data.allOrgaccount &&
    data.allOrgaccount.edges[0] &&
    data.allOrgaccount.edges[0].node &&
    data.allOrgaccount.edges[0].node.discountProgress &&
    data.allOrgaccount.edges[0].node.discountProgress.discountAvailable;

  const discountCheckout = (planId) => {
    const url = "/#/dashboards/plofile-organization";
    let target1 = document.getElementById("csoPriceButton1");
    let target2 = document.getElementById("csoPriceButton2");

    if (discountStatus) {
      checkout(planId);
    } else {
      alert(
        "CSO料金プランの契約には、各種書類の提出が必要です。\n\n次の画面から必要書類をご提出ください。"
      );
      target1.setAttribute("href", url);
      target2.setAttribute("href", url);
      setOrgActiveTab("5");
    }
  };

  return (
    <Fragment>
      <div>
        <div className="pricePran_sec">
          <h2 className="pricePlanTitle">料金プラン</h2>
          <div className="price__cso__btn">
            <Button
              onClick={() => {
                if (orgPk === "このユーザーは組織と紐づいていません") {
                  noOrgUserModalToggle();
                } else {
                  setCso(!cso);
                }
              }}
              className="ema__btn__main"
            >
              {cso ? "一般の方はこちら" : "CSOの方はこちら"}
            </Button>
          </div>

          <div className="priceItems">
            <div className="sku">
              <div className="detail">
                <h4 className="name">Freeプラン</h4>
                {cso && <div className="cso__margin"></div>}
                <div className="price">
                  <div className="value">
                    ¥ 0<span>/月</span>
                  </div>
                  <div
                    className="clarifications"
                    style={{ visibility: "hidden" }}
                  >
                    ユーザーあたりの月額
                  </div>
                </div>

                <div className="" style={{ height: "44px" }}></div>
              </div>

              <ul className="features">
                <li>
                  <img src={Check} />
                  <span>ユーザー数:1枠</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>ソーシャルマップ利用</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>トレンド情報</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>マイページ利用</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>オーガニゼーション（一部）</span>
                </li>
              </ul>
            </div>
            <div className="sku">
              {/* <div class="most-popular">最も人気のアイテム</div> */}
              <div className="detail">
                <h4 className="name">Basic 月プラン</h4>
                {cso && <div className="cso__margin"></div>}
                <div className="price">
                  <div className="value">
                    ¥ 30,000<span>/月</span>
                  </div>

                  {cso && (
                    <div className="discount_price">
                      <div className="discount_value">¥ 15,000</div>
                      <span></span>
                    </div>
                  )}
                  <div
                    className="clarifications"
                    style={{ visibility: "hidden" }}
                  >
                    ユーザーあたりの月額
                  </div>
                </div>

                {cso ? (
                  <a
                    id="csoPriceButton1"
                    className="ctaBtn csoPriceButton pointer"
                    onClick={() => discountCheckout("1051")}
                  >
                    使ってみる
                  </a>
                ) : (
                  <a
                    className="ctaBtn pointer"
                    onClick={() => checkout("1041")}
                  >
                    使ってみる
                  </a>
                )}
              </div>

              <ul className="features">
                <li>
                  <img src={Check} />
                  <span>ユーザー数:3枠 (※2)</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>ソーシャルマップ利用</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>トレンド情報</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>マイページ利用</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>オーガニゼーション</span>
                </li>
              </ul>
            </div>
            <div className="sku">
              <div className="detail">
                <h4 className="name" style={{ position: "relative" }}>
                  Basic 年プラン
                  {cso && (
                    <spna
                      style={{
                        fontSize: "0.8rem",
                        position: "absolute",
                        top: "-9px",
                      }}
                    >
                      {" "}
                      ※4
                    </spna>
                  )}
                </h4>
                {cso && <div className="cso__margin"></div>}
                <div className="price">
                  <div className="value">
                    ¥ 216,000<span>/年</span>
                  </div>
                  {cso && (
                    <div className="discount_price">
                      <div className="discount_value">¥ 108,000</div>
                      <span></span>
                    </div>
                  )}

                  <div className="clarifications">
                    月あたり{cso ? "¥ 9,000" : "¥ 18,000"}
                  </div>
                </div>

                {cso ? (
                  <a
                    id="csoPriceButton2"
                    className="ctaBtn csoPriceButton pointer"
                    onClick={() => discountCheckout("1021")}
                  >
                    使ってみる
                  </a>
                ) : (
                  <a
                    className="ctaBtn pointer"
                    onClick={() => checkout("1011")}
                  >
                    使ってみる
                  </a>
                )}
              </div>
              <ul className="features">
                <li>
                  <img src={Check} />
                  <span>ユーザー数:3枠 (※2)</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>ソーシャルマップ利用</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>トレンド情報</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>マイページ利用</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>オーガニゼーション</span>
                </li>
                {/* <li>
                  <img src={Check} />
                  <span>組織情報の詳細閲覧</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>組織リスト検索</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>パートナーシップマネジメント</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>データダウンロード:20行/月 (※3)</span>
                </li> */}
              </ul>
            </div>
            <div className="sku">
              <div className="detail">
                <h4 className="name">Pro 年プラン</h4>
                {cso && <div className="cso__margin"></div>}
                <div className="price">
                  <div className="clarifications">お問い合わせ</div>
                </div>
                <a className="ctaBtn" href="#/dashboards/contact">
                  問い合わせる
                </a>
              </div>

              <ul className="features">
                <li>
                  より広範なデータダウンロード(※3)、詳細レポート、組織全社で利用するためのユーザー設定、EMAデータ活用サポートが必要な方はこちらへ
                </li>
              </ul>
            </div>
          </div>
          <div className="price_commentarea">
            <ul>
              <li>
                ※1
                　必要項目をエクセルもしくはEMA指定のフォームにて提出。組織診断を年1回以上実施
              </li>
              <li>
                ※2
                　3ユーザー以上の利用ご希望の際は、別途お問合せください。割引条件を設定してご提案させて頂きます
              </li>
              <li>※3　より精度の高い組織情報リストご提供</li>
              {cso && <li>※4　JANIC正会員の方には、Basic年プランをご提供</li>}
            </ul>
          </div>
        </div>

        <Modal isOpen={noOrgUserModal} toggle={noOrgUserModalToggle}>
          <ModalBody className="mt-3 ml-3 mr-3 ">
            <p className="bold" style={{ marginBottom: 30 }}>
              CSOプランを適用するには、組織登録が必要です。
              <br />
              画面右上の「組織登録ボタン」より登録してください。
            </p>

            <img
              style={{ width: "100%", margin: "auto" }}
              src={registerExplainImage}
            ></img>
          </ModalBody>
          <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
            <Button
              className="mb-2"
              style={{ margin: "auto" }}
              onClick={noOrgUserModalToggle}
            >
              閉じる
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </Fragment>
  );
};

export default Pricing;
